import { Box, Button, Input} from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import { PopupLayout } from '../../PopupLayout/PopupLayout';

const EquipmentPropertyPopup = ({ closeEquipmentPropPopup, element_Id, equipment, element_View, label_Text, startPos/*, updateLinks*/ }) => {
	const componentRef = useRef(null);

  return (
    <PopupLayout
    title={label_Text}
    closeFunction={() => closeEquipmentPropPopup(element_Id)} 
    pageX={startPos.x}
    pageY={startPos.y}
    id={element_Id} //pass element_ID as unique identifier
    componentRef={componentRef}>
      <Box className='stream-property-bottom-half'>
      {equipment.attributes.components && (
        Object.entries(equipment.attributes.components).map(([key, value], index) => (
            <React.Fragment key={key + index}>
                <Box className='stream-property-label' color="black" fontSize={"15"}>{key}</Box>
                <Input
                    className='stream-property-input'
                    value={value.M}
                    readOnly
                />
                <Input
                    className='stream-property-input'
                    value="g/Mol"
                    readOnly
                    disabled={true}
                />
            </React.Fragment>
          ))
        )}

      </Box>
        </PopupLayout>
  );
};

export default EquipmentPropertyPopup;
